import random from 'lodash/random';

import { useGraphqlSettings } from '../config';

const MIN_BACKOFF = 1_000;

/**
 * Returns a random backoff time.
 * The minimum backoff time is 1 second.
 */
export const useRefetchBackoff = () => {
  const { subscriptions } = useGraphqlSettings();

  return MIN_BACKOFF + random() * subscriptions.refetch.backoff;
};
